import TeacherStudentSettingsHeader from "../../components/TeacherStudentSettingsHeader/TeacherStudentSettingsHeader";
import '../StudentProfile/StudentProfile.scss';
import { useAppSelector } from "../../redux/app/hooks";
import TeacherProfileForm from "../../components/TeacherProfileForm/TeacherProfileForm";
import { useEffect } from "react";
import { logout, setAdminProfile, setAdminProfileImage, setRefetchCurrentUser } from "../../redux/slices/authSlice";
import { useDispatch } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import { GET_CURRENT_USER } from "../AdminDashboard/api/AdminDashboardQuery";
import ToasterWithMessage from "../../components/toaster";
import images from "../../assets/images";
import { FETCH_POLICY_NO_CACHE, SCHOOL_ADMIN, STUDENT_ROLE } from "../../utils/constants";

const TeacherProfile = () => {

    const profile = useAppSelector((state) => state.auth.adminProfile?.getCurrentUser?.nodes?.[0]);    
    const dispatch = useDispatch();
    const {error} = ToasterWithMessage()
    const { schoolProfileImage } = images;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const role = useAppSelector((state) => state.auth.role);
    const studentClasscode: string |null = localStorage.getItem('studentClassCode')

    const [getCurrentUser, { loading }] = useLazyQuery(GET_CURRENT_USER,{
            fetchPolicy: FETCH_POLICY_NO_CACHE,
            onCompleted: (data) => {
              if(data && data?.getCurrentUser){
                    dispatch(setAdminProfile({profile: data}));
                    dispatch(setAdminProfileImage({ adminProfileImage: role === SCHOOL_ADMIN ? data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl : schoolProfileImage : data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
              }else {
                error("User Not Found!");
              }
            },
            onError: (err) => {
              error(err?.message);
              dispatch(logout());
            }
          });
    
    useEffect(() => {
        if(role === STUDENT_ROLE){
                getCurrentUser({
                  variables : {
                    classCode : studentClasscode
                  }
                })
              }
            else {
              getCurrentUser({
                variables : {
                    classCode : ""
                  }
              });
            }
        // dispatch(setRefetchCurrentUser({ refetchCurrentUser: true }));
    }, [])

    return (
        <div className="studentProfile">
            <div className="studentProfileHeader">
                <TeacherStudentSettingsHeader
                    title="My Profile"
                />
            </div>
            <div className="FormContainer">
                {(profile) && (
                    <TeacherProfileForm
                        id={profile?.teachersByUId?.nodes?.[0]?.tId}
                        fullName={profile?.uFullName}
                        username={profile?.uUserName}
                        password={profile?.uUserPassword}
                        avatarUrl={profile?.teachersByUId?.nodes?.[0]?.tAvatarUrl} 
                    />
                )}
            </div>
        </div>
    )
}

export default TeacherProfile;